var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 864h-32V363c0-20.167-7.765-39.038-21.863-53.137S841.167 288 821 288H704V172c0-20.167-7.765-39.038-21.863-53.137C668.038 104.765 649.167 97 629 97H204c-41.907 0-76 33.645-76 75v692H96c-17.673 0-32 14.327-32 32s14.327 32 32 32h832c17.673 0 32-14.327 32-32s-14.327-32-32-32zM821 351c6.953 0 12 5.047 12 12v501H704V351h117zM191 172c0-6.617 5.832-12 13-12h425c6.953 0 12 5.047 12 12v692h-65V607.5c0-52.107-42.393-94.5-94.5-94.5h-130c-52.107 0-94.5 42.393-94.5 94.5V864h-66V172z m322 692H320V607.5c0-17.369 14.131-31.5 31.5-31.5h130c17.369 0 31.5 14.131 31.5 31.5V864z",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287 321h256c17.673 0 32-14.327 32-32s-14.327-32-32-32H287c-17.673 0-32 14.327-32 32s14.327 32 32 32zM287 448h256c17.673 0 32-14.327 32-32s-14.327-32-32-32H287c-17.673 0-32 14.327-32 32s14.327 32 32 32z",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.3537fbe06ab7386e120924317187122c.svg";
export { ForwardRef as ReactComponent };